"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedAutocomplete = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
var StyledAutocomplete = (0, styles_1.styled)(Autocomplete_1.default)(function (_a) {
    var theme = _a.theme, value = _a.value;
    return ({
        '.MuiAutocomplete-input': {
            padding: '1.2rem 0rem !important',
        },
        '.MuiAutocomplete-inputRoot': __assign({ padding: 0, paddingLeft: '2rem' }, (Array.isArray(value) && value.length && { padding: '10px' })),
        '.MuiAutocomplete-paper': {
            marginTop: '0.4rem',
            borderWidth: '2px',
            borderStyle: 'solid',
            borderColor: theme.palette.primary[200],
        },
        '.MuiAutocomplete-tag': {
            backgroundColor: theme.palette.primary[200],
            height: 26,
            position: 'relative',
            zIndex: 0,
            '& .MuiChip-label': {
                color: theme.palette.primary[600],
            },
            '& .MuiChip-deleteIcon': {
                color: theme.palette.primary[200],
                '&:hover': {
                    color: theme.palette.primary[200],
                },
            },
            '&:after': {
                content: '""',
                right: 10,
                top: 6,
                height: 12,
                width: 12,
                position: 'absolute',
                backgroundColor: '#200E32',
                opacity: 0.4,
                zIndex: -1,
            },
        },
    });
});
var ThemedAutocomplete = function (props) {
    return (0, jsx_runtime_1.jsx)(StyledAutocomplete, __assign({}, props));
};
exports.ThemedAutocomplete = ThemedAutocomplete;
